module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 029.a9fa1251.jpg";